<template>
  <div>
    <div class="invite-content-title">
      <a-breadcrumb separator="/">
        <a-breadcrumb-item
          class="breadcrumb-item"
          @click.native="handleBack"
        >
          {{ projectName }}
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{ $t('message["1439"]') }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="content-send-title">
      <p>{{ $t('message["1212"]') }}</p>
      <p>{{ $t('message["281"]') }}</p>
    </div>
    <div class="form-content">
      <a-form
        ref="inviteForm"
        layout="inline"
        :form="form"
        @submit.prevent="handleSubmit"
      >
        <div
          v-for="(item,index) in formDatas"
          :key="index"
          class="item-div"
        >
          <a-form-item>
            <a-input
              v-decorator="[`email[${index}]`,{
                validateTrigger: ['change', 'blur'],
                rules: [{
                  type: 'email', message: emailTipTxt,
                }, {
                  required: true,whitespace: true, message: emailPlaceholder
                }]
              }]"
              class="email-input"
              :placeholder="emailPlaceholder"
              @blur="handleBlur(index)"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[`nickname[${index}]`,{
                validateTrigger: ['change', 'blur'],
                rules: [{
                  required: true, message: truenamePlace
                }]
              }]"
              :disabled="item.isreg===1?true:false"
              class="nickname-input"
              :placeholder="truenamePlace"
              @blur="handleNickNameBlur(index)"
            />
          </a-form-item>
          <a-form-item>
            <a-select
              v-decorator="[`roleInfo[${index}]`,{
                validateTrigger: [],
                rules: [{
                  required: true, message: selectRolePlace
                }]
              }]"
              :placeholder="selectRolePlace"
              class="role-select"
              :disabled="roleStatus"
              @change="handleRoleChange($event,index)"
            >
              <a-select-option
                v-for="items in roleArrayValue"
                :key="items.roleid"
                :value="items.roleid+'-'+items.system_role"
              >
                {{ items.rolename }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-if="item.sysrole*1!==2">
            <a-select
              v-if="item.sysrole*1===1"
              v-decorator="[`groupInfo[${index}]`,{
                rules: [{
                  required:false, message: selectGroupPlace,trigger: 'blur'
                }]
              }]"
              class="group-select"
              :disabled="groupStatus"
              :placeholder="selectGroupPlace"
            >
              <a-select-opt-group
                v-for="itemgroup in item.groupData"
                :key="itemgroup.roleid"
                :label="itemgroup.teamname"
              >
                <a-select-option
                  v-for="(itemoptgroup) in itemgroup.groups"
                  :key="itemoptgroup.groupid"
                  :value="itemoptgroup.groupid"
                >
                  {{ itemoptgroup.groupname }}
                </a-select-option>
              </a-select-opt-group>
            </a-select>
            <a-select
              v-else
              v-decorator="[`groupInfo[${index}]`,{
                rules: [{
                  required: true, message: selectGroupPlace,trigger: 'blur'
                }]
              }]"
              class="group-select"
              :disabled="groupStatus"
              :placeholder="selectGroupPlace"
            >
              <a-select-option
                v-for="items in item.groupData"
                :key="items.groupid"
              >
                {{ items.groupname }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <span
              v-if="formDatas.length>1&&index>=1"
              class="delete-span"
              @click="remove(index)"
            >
              {{ $t('message["962"]') }}
            </span>
          </a-form-item>
        </div>
        <div class="add-div">
          <a-form-item>
            <span
              class="add-btn-span"
              @click="addItem"
            >
              <a-icon type="plus" /> {{ $t('message["1190"]') }}
            </span>
          </a-form-item>
        </div>
        <div>
          <a-form-item>
            <a-button
              v-if="formDatas.length>0"
              type="primary"
              html-type="submit"
            >
              {{ $t('message["279"]') }}
            </a-button>
          </a-form-item>
        </div>
      </a-form>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { setTimeout } from 'timers'
export default {
  data () {
    return {
      formDatas: [{
        email: '',
        nickname: '',
        roleInfo: '',
        groupInfo: '',
        groupData: [],
        isreg: 0,
        groupid: ''
      }],
      tempRoleValue: '',
      roleStatus: false,
      groupStatus: false,
      roleArrayValue: [],
      projectName: '',
      defaultRoleId: '',
      defaultGroupId: '',
      roleInfo: null,
      groupInfo: null
    }
  },
  computed: {
    ...mapState('team/member', ['roleList', 'groupList']),
    ...mapState('team/manage', ['treeDatas', 'inviteIsregList', 'roleId', 'teamItemName', 'selectTreenDataKey', 'treeDefaultKey', 'inviteNewMemberVisible']),
    emailTipTxt () {
      return this.$t('message["683"]')
    },
    truenamePlace () {
      return this.$t('message["788"]')
    },
    emailPlaceholder () {
      return this.$t('message["828"]')
    },
    selectRolePlace () {
      return this.$t('message["869"]')
    },
    selectGroupPlace () {
      return this.$t('message["885"]')
    }
  },
  watch: {
    teamItemName (val) {
      if (!val) return
      this.projectName = val
    },
    treeDatas (val) {
      if (val) {
        const [item] = val
        this.projectName = item.title
        document.title = this.$t('message["1228"]') + `-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
      }
    },
    roleList (val) {
      if (!val) return
      this.roleArrayValue = val
      let tempv = ''
      if (this.selectTreenDataKey) {
        tempv = this.selectTreenDataKey
      } else {
        tempv = this.treeDefaultKey[0]
      }
      this.initViewDatas(tempv)
    },
    groupList: {
      handler (val) {
        if (!val) return
        if (val.length <= 0) return
        let groupLists = val[0].groupArray
        if (Array.isArray(groupLists)) {
          groupLists.map(value => {
            value.groupid = value.groupid.toString()
            if (value.groups) {
              value.groups.map(item => {
                item.groupid = item.groupid.toString()
              })
            }
          })
          if (this.roleStatus) {
            let datas = JSON.parse(JSON.stringify(this.formDatas))
            datas.map(vvs => {
              vvs.groupData = groupLists
            })
            this.formDatas = datas
          } else {
            let indexs = val[0].index
            if (indexs >= 0) {
              let temp = this.formDatas[indexs]
              temp.groupData = groupLists
              this.$set(this.formDatas, indexs, temp)
            }
          }
        }
      },
      immediate: true
    },
    inviteIsregList (val) {
      if (val) {
        let tempv = JSON.parse(JSON.stringify(this.formDatas))
        const nickname = this.form.getFieldValue('nickname')
        tempv.map((values, index) => {
          nickname[index] = values.nickname
          if (val.email === values.email) {
            values.isreg = val.isreg
            values.truename = val.truename
            if (val.truename) {
              nickname[index] = val.truename
            }
          }
        })
        this.formDatas = tempv
        this.form.setFieldsValue({ nickname: nickname })
      }
    },
    selectTreenDataKey (val) {
      if (!val) return
      this.initViewDatas(val)
    }
  },
  created () {
    this.form = this.$form.createForm(this)
    this.form.getFieldDecorator('isreg', { initialValue: [], preserve: true })
  },
  mounted () {
    if (this.teamItemName) {
      this.projectName = this.teamItemName
    }
  },
  methods: {
    ...mapActions('team/member', ['fetchGetGroups']),
    ...mapActions('team/manage', ['changInviteMemberVisible', 'changeTreeDefaultKey', 'fetchEmailIsRegister', 'fetchInviteMemberDatas']),
    // 表单动态添加操作
    addItem () {
      this.formDatas.push({
        email: '',
        nickname: '',
        roleInfo: '',
        groupInfo: '',
        sysrole: null,
        groupData: [],
        isreg: 0,
        groupid: ''
      })
      if (this.selectTreenDataKey) {
        setTimeout(() => {
          this.initViewDatas(this.selectTreenDataKey)
        }, 100)
      }
    },
    initViewDatas (val) {
      this.form.resetFields(`groupInfo`)
      this.form.resetFields(`roleInfo`)
      let roleArray = []
      let groupArray = []
      let json = {}
      let roleId = ''
      let groupId = ''
      if (val.indexOf('|') >= 0) {
        const [roleArr, groupArr] = val.split('|')
        this.defaultGroupId = val
        const roleArrInfo = roleArr.split('-')
        const groupArrInfo = groupArr.split('-')
        roleId = roleArrInfo[1]
        groupId = groupArrInfo[1]
      } else {
        const [name, id] = val.split('-')
        if (name === 'roleid') {
          roleId = id
          this.defaultRoleId = val
        }
      }
      this.formDatas.map((value, index) => {
        value.roleInfo = roleId
        value.groupInfo = groupId
        if (this.roleArrayValue) {
          this.roleArrayValue.some(item => {
            if (item.roleid === roleId) {
              item.groupData = []
              this.tempRoleValue = `${roleId}-${item.system_role}`
              value.sysrole = item.system_role
              value.roleid = roleId
              roleArray.push(this.tempRoleValue)
              return true
            }
          })
        }
        groupArray.push(`${groupId}`)
      })
      if (roleId) {
        if (groupId) {
          json = {
            groupInfo: groupArray,
            roleInfo: roleArray
          }
          this.roleStatus = true
          this.groupStatus = true
          this.handleRoleChange(val, 0, 'init')
        } else {
          json = {
            roleInfo: roleArray
          }
          this.roleStatus = true
          this.groupStatus = false
          this.handleRoleChange(val, 0, 'init')
        }
      } else {
        this.roleStatus = false
        this.groupStatus = false
      }
      if (JSON.stringify(json) !== '{}') {
        this.form.setFieldsValue(json)
      }
    },
    // 表单类目动态删除
    remove (index) {
      this.formDatas = this.formDatas.slice(0, index).concat(this.formDatas.slice(index + 1))
      this.form.clearField([`email[${index}]`])
      this.form.clearField([`nickname[${index}]`])
      this.form.clearField([`roleInfo[${index}]`])
      this.form.clearField([`groupInfo[${index}]`])
    },
    setFormData (param, data) {
      if (!data) {
        return
      }
      const { formDatas } = this
      for (let i = 0; i < data.length; i++) {
        if (param === 'roleInfo') {
          const itemArr = data[i].split('-')
          if (itemArr.length === 2) {
            formDatas[i].roleid = itemArr[0]
          }
        } else if (param === 'groupInfo') {
          if (data[i]) {
            formDatas[i].groupid = data[i]
          } else {
            formDatas[i].groupid = ''
          }
        } else if (param === 'nickname') {
          formDatas[i].truename = data[i]
        } else {
          formDatas[i][param] = data[i]
        }
      }
    },
    // 表单提交
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, data) => {
        if (!err) {
          this.setFormData('email', this.form.getFieldValue('email'))
          this.setFormData('nickname', this.form.getFieldValue('nickname'))
          this.setFormData('roleInfo', this.form.getFieldValue('roleInfo'))
          if (this.form.getFieldValue('groupInfo')) {
            this.setFormData('groupInfo', this.form.getFieldValue('groupInfo'))
          } else {
            this.setFormData('groupInfo', [''])
          }
          this.fetchInviteMemberDatas(this.formDatas)
          this.handleBack()
        }
      })
    },
    // 邮箱验证
    async handleBlur (k) {
      this.formDatas[k].email = this.form.getFieldValue(`email[${k}]`)
      if (this.form.getFieldValue(`email[${k}]`).trim !== '') {
        const chain = await this.fetchEmailIsRegister({ email: this.form.getFieldValue(`email[${k}]`), index: k })
        chain.onSuccess(raw => {
          this.formDatas[k].nickname = raw.truename
        })
          .fetch()
      }
    },
    handleNickNameBlur (index) {
      this.formDatas[index].nickname = this.form.getFieldValue(`nickname[${index}]`)
    },
    // 点击选中项目返回操作
    handleBack () {
      this.changInviteMemberVisible(false)
    },
    // 级联选择操作
    handleRoleChange (value, index, type) {
      if (type) {
        if (value.indexOf('-') >= 0) {
          const role = value.split('-')
          this.fetchGetGroups({ roleid: role[1], index: index })
        }
      } else {
        this.form.resetFields(`groupInfo[${index}]`)
        if (value.indexOf('-') >= 0) {
          const [roleid, sysrole] = value.split('-')
          let json = this.formDatas[index]
          json.sysrole = sysrole * 1
          json.roleid = roleid
          json.groupData = []
          this.$set(this.formDatas, index, json)
          if (sysrole * 1 !== 2) {
            this.fetchGetGroups({ roleid, index: index })
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.invite-content-title {
  padding: 5px 0px 15px 0px;
  margin-left: 40px;
  border-bottom: solid 1px #dcdfe6;
  .breadcrumb-item {
    color: #5077aa;
    cursor: pointer;
  }
}
.content-send-title {
  padding: 0px 0px 10px 0px;
  margin-left: 40px;
  margin-top: 24px;
  p {
    height: 25px;
    &:last-child {
      color: #c0c4cc;
    }
  }
}
.form-content {
  margin-left: 40px;
  .delete-span {
    color: #5077aa;
    cursor: pointer;
    padding: 4px 12px 4px 12px;
    &:hover {
      border-radius: 4px;
      box-shadow: inset 0 2px 0 0 rgba(255, 255, 255, 0.5);
      border: solid 1px #ebebeb;
      background-color: #ffffff;
      padding: 4px 12px 4px 12px;
    }
  }
  .item-div {
    margin-bottom: 20px;
  }
  .email-input {
    width: 175px;
  }
  .group-select {
    width: 180px;
  }
  .role-select {
    width: 150px;
  }
  .nickname-input {
    width: 110px;
  }
  .add-div {
    padding: 4px 0px 24px 0px;
    .add-btn-span {
      background-color: #f5f5f5;
      padding: 4px 8px 4px 8px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>
